/**
 * Shared constants for the application
 */

export type DayOfWeek =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday'

export const DAYS_OF_WEEK: DayOfWeek[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
]

export const DAY_DISPLAY_NAMES: Record<DayOfWeek, string> = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday'
}

// Split Builder constants
export const DEFAULT_REST_SECONDS = 90
export const MIN_KANBAN_HEIGHT = 'min-h-96'
export const DEFAULT_SET_COUNT = 3
export const MIN_SET_COUNT = 1
export const ID_LENGTH = 9

export const DISCORD_INVITE_URL = 'https://discord.gg/fXbfR73jZ4'
export const DEFAULT_LOADLINE_IOS_APP_URL =
  'https://apps.apple.com/us/app/loadline-gym-tracker-logger/id6749194369#productRatings'

const configuredAppStoreUrl = import.meta.env.VITE_APP_STORE_URL?.trim()

export const LOADLINE_IOS_APP_URL = configuredAppStoreUrl || DEFAULT_LOADLINE_IOS_APP_URL
export const HAS_LOADLINE_IOS_APP_URL = Boolean(
  configuredAppStoreUrl || DEFAULT_LOADLINE_IOS_APP_URL
)
